export const defaultCfopParameterizationState = () => ({
  id: undefined,
  origin: {
    id: null,
    code: null,
    description: '',
  },
  conversion: {
    id: null,
    code: null,
    description: '',
  },
});

const defaultCfopParameterizationsModuleState = () => ({
  summaryCfopParameterizations: [],
  paginationCfopParameterizations: {
    perPage: 15,
    currentPage: 1,
  },
});

const initialState = {
  ...defaultCfopParameterizationsModuleState(),
  cfopParameterization: {
    ...defaultCfopParameterizationState(),
  },
};

export default {
  ...initialState,
};
